import React from "react";
import { Form, Input, DatePicker, Select, Radio, Upload, Row } from "antd";
import { Col } from "antd";

const { Option } = Select;

const dischargeStageOptions = [
  { label: "After Surgery/Treatment", value: "After Surgery/Treatment" },
];
const lamaStageOptions = [
  { label: "Before Surgery/Treatment", value: "Before Surgery/Treatment" },
  { label: "After Surgery/Treatment", value: "After Surgery/Treatment" },
];
const damaStageOptions = lamaStageOptions;
const deathStageOptions = [
  { label: "Before Surgery/Treatment", value: "Before Surgery/Treatment" },
  {
    label: "Death on table with incision",
    value: "Death on table with incision",
  },
  { label: "Without incision", value: "Without incision" },
  { label: "After Surgery/Treatment", value: "After Surgery/Treatment" },
];

const DischargeFields = ({ type, form }: { type: string; form: any }) => {
  switch (type) {
    case "Normal Discharge":
      return (
        <Form layout="vertical" form={form}>
          <Row gutter={[16, 24]}>
            <Col span={8}>
              <Form.Item
                label="Discharge Stage"
                name="stage"
                rules={[
                  {
                    required: true,
                    message: "Select Discharge Stage",
                  },
                ]}
              >
                <Select
                  options={dischargeStageOptions}
                  placeholder="Select Discharge Stage"
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Discharge Date"
                name="dateOfDischarge"
                rules={[
                  {
                    required: true,
                    message: "Select Discharge Date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" showTime style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Surgery Treatment Date"
                name="surgeryDate"
                rules={[
                  {
                    required: true,
                    message: "Select Surgery Treatment Date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Have Hospital provided the medicines during treatment for post operative care"
                name="medicinesProvided"
                rules={[
                  {
                    required: true,
                    message:
                      "Select Hospital provided the medicines during treatment for post operative care",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      );
    case "LAMA":
      return (
        <Form layout="vertical" form={form}>
          <Row gutter={[16, 24]}>
            <Col span={8}>
              <Form.Item
                label="LAMA Stage"
                name="stage"
                rules={[
                  {
                    required: true,
                    message: "Select lama stage",
                  },
                ]}
              >
                <Select
                  options={lamaStageOptions}
                  placeholder="Select lama stage"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Surgery Treatment Date"
                name="surgeryDate"
                rules={[
                  {
                    required: true,
                    message: "Select Surgery Date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="LAMA Date"
                name="dateOfDischarge"
                rules={[
                  {
                    required: true,
                    message: "Select lama Date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Have Hospital provided the medicines during treatment for post operative care"
                name="medicinesProvided"
                rules={[
                  {
                    required: true,
                    message:
                      "Select Hospital provided the medicines during treatment for post operative care",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      );
    case "DAMA":
      return (
        <Form layout="vertical" form={form}>
          <Row gutter={[16, 24]}>
            <Col span={8}>
              <Form.Item
                label="DAMA Stage"
                name="stage"
                rules={[
                  {
                    required: true,
                    message: "Select dama stage",
                  },
                ]}
              >
                <Select
                  options={damaStageOptions}
                  placeholder="Select dama stage"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Surgery Treatment Date"
                name="surgeryDate"
                rules={[
                  {
                    required: true,
                    message: "Select surgery date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Discharge Date"
                name="dateOfDischarge"
                rules={[
                  {
                    required: true,
                    message: "Select discharge date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      );
    case "Death":
      return (
        <Form layout="vertical" form={form}>
          <Row gutter={[16, 24]}>
            <Col span={8}>
              <Form.Item
                label="Death Stage"
                name="stage"
                rules={[
                  {
                    required: true,
                    message: "Select death stage",
                  },
                ]}
              >
                <Select
                  options={deathStageOptions}
                  placeholder="Select death stage"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Death Date"
                name="dateOfDischarge"
                rules={[
                  {
                    required: true,
                    message: "Select death date",
                  },
                ]}
              >
                <DatePicker format="DD-MM-YYYY HH:mm:ss" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      );
    default:
      return null;
  }
};

export default DischargeFields;
